// This file contains all the config for the natural language interface

module.exports = 
{
  "version": "5.51.42",
  "thinktelligence": {
    //"server": 'http://Think-Think-1X3G67237CVP3-872441962.ca-central-1.elb.amazonaws.com/api'
    //"server": 'https://thinktelligence.com/api'
    "url": 'http://localhost:10000/api'
    //"server": 'http://184.67.27.82:5000'
  },
  "entodicton": {
    "url": "http://184.67.27.82",
    "apiKey": "6804954f-e56d-471f-bbb8-08e3c54d9321"
  },
  "idiocy": [
    "we put the think in telligence",
    "code from the future today",
    "i thought you bought the peanut butter",
    "ramanujan that's why"
  ]
};
